const supportedImageMimeTypes = [
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/bmp",
]

export const isImageTypeSupported = (mimeType: string) => {
  return supportedImageMimeTypes.includes(mimeType);
}

export const getSupportedImageTypes = () : string => {
  return supportedImageMimeTypes.reduce((prev, curr) => prev.concat(', ', curr));
}